<template>
  <div>
    <div style="padding-bottom: 20px">
      <div v-loading="nalaganjePoslovanje">
        <p class="open-sans-30pt">
          ePOSLOVANJE
        </p>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Z vklopom ePoslovanja boste hitro, učinkovito in varno urejali vaše naročniško razmerje po
            elektronski pošti, lastnoročni podpisi in izpolnjeni obrazci pa ne bodo več potrebni. <br>
            Vse spremembe naročniškega razmerja boste urejali preko vpisanega e-naslova.
          </p>
        </div>
        <div style="padding-top: 10px">
          <p class="navadno-besedilo">
            <b>
              Z vklopom ePoslovanja soglašate z uporabo emaila v namen brezpapirnega poslovanja.
            </b>
          </p>
        </div>
        <div style="padding-top: 20px">
          <p class="odmik-bottom">
            Elektronski naslov za ePoslovanje
          </p>
          <div>
            <el-input placeholder="Vnesite elektronski naslov." v-model="novEmailZaEposlovanje"
                      v-bind:disabled="moznostVnosaEposlovanje" class="velikost-input">
            </el-input>
            <div v-if="this.potrditevEposlovanje === true" class="postavitev-gumba">
              <el-button v-if="!potrditevConfirmed" v-on:click="PotrditevEmaila"
                         class="postavitev-gumba-ponovno-poslji-mail">
                <b style="color: #080809">
                  PONOVNO POŠLJI POTRDITVEN EMAIL
                </b>
              </el-button>
            </div>
          </div>
        </div>
        <div class="odmik-vklop-izklop-eposlovanja">
          <span v-if="soglasjeEmail === true" @change="PosodobiEposlovanje" style="padding-top: 10px">
            <a class="okvir-izklopa tekst-okvir-izklopa" @click="IzklopimoEposlovanje">
              IZKLOPI
            </a>
          </span>
          <span v-else>
            <el-button class="gumb-potrdi" @click="VklopimoEposlovanje">
              VKLOPI
            </el-button>
          </span>
        </div>
        <div style="padding-top: 21px">
          <b>
            <i>
              <img :src="ikonaZaPrikazStatusa" class="Icon-awesome"/>
            </i>
            STATUS:
          </b>
          {{ statusEposlovanje }}
        </div>
        <div v-if="soglasjeEmail">
          <InfoKomponentaEposlovanje/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {Input, Button, Select, Option, MessageBox, Checkbox} from 'element-ui'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import InfoKomponentaEposlovanje from './InfoKomponentaEposlovanje.vue'

export default {
  name: 'EposlovanjeComponent',
  data () {
    return {
      clientAgent: null,
      moznostVnosaEposlovanje: false,
      soglasjeEmail: false,
      nalaganjePoslovanje: true,
      novEmailZaEposlovanje: '',
      potrditevEposlovanje: false,
      statusEposlovanje: '',
      ikonaZaPrikazStatusa: '',
      validacija: null
    }
  },
  props: {
    izbranaStranka: null,
    izbranaStrankaSap: null
  },
  watch: {
    izbranaStrankaSap: function () {
      if (this.izbranaStrankaSap !== null) {
        this.PreveriStatusEPoslovanja()
        this.novEmailZaEposlovanje = ''
      }
    }
  },
  components: {
    InfoKomponentaEposlovanje,
    [Button.name]: Button,
    [Input.name]: Input,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [Option.name]: Option
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.validacija = new Validacija()
  },
  methods: {
    PosodobiEposlovanje () {
      if (this.izbranaStrankaSap !== '') {
        if (this.validacija.EmailValid(this.novEmailZaEposlovanje)) {
          this.VklopimoEposlovanje()
          this.moznostVnosaEposlovanje = true
        } else if (this.novEmailZaEposlovanje !== '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Pred vključitvijo je potrebno vnesti email naslov.'
          this.ShowWarningMessage(paramObvestilo)
          this.moznostVnosaEposlovanje = false
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Neveljavna oblika emaila.'
          this.ShowWarningMessage(paramObvestilo)
          this.moznostVnosaEposlovanje = false
        }
      }
      this.nalaganjePoslovanje = false
    },
    async PreveriStatusEPoslovanja () {
      if (this.izbranaStrankaSap !== '') {
        this.nalaganjePoslovanje = true
        let response = await this.clientAgent.makeRequest(
          'stranka/eposlovanje/preveriEposlovanje',
          {idStranka: parseInt(this.izbranaStranka)},
          'GET'
        ).catch((e) => this.ErrPreveriStatusEPoslovanja(e))
        this.SetPreveriStatusEPoslovanja(response)
      }
    },
    SetPreveriStatusEPoslovanja (podatki) {
      this.potrditevEposlovanje = podatki.eposlovanje
      this.potrditevConfirmed = podatki.confirmed
      this.novEmailZaEposlovanje = podatki.email
      if (this.potrditevEposlovanje) {
        this.soglasjeEmail = true
        this.moznostVnosaEposlovanje = true
      } else {
        this.soglasjeEmail = false
        this.moznostVnosaEposlovanje = false
      }
      if (this.potrditevEposlovanje === false) {
        this.statusEposlovanje = 'Izključeno.'
        this.ikonaZaPrikazStatusa = '/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png'
      } else if (this.potrditevEposlovanje === true && this.potrditevConfirmed === false) {
        this.statusEposlovanje = 'ePoslovanje ni vklopljeno. Potrebna potrditev e-naslova.'
        this.ikonaZaPrikazStatusa = '/static/img/Domov/Icon-awesome-exclamation-triangle-black.png'
      } else if (this.potrditevEposlovanje === true) {
        this.ikonaZaPrikazStatusa = '/static/img/kljukica2.svg'
        if (podatki.dateConfirmed !== undefined) {
          this.statusEposlovanje = 'Vklopljeno dne ' +
            podatki.dateConfirmed.substring(0, 10).replace('-', '.').replace('-', '.')
        }
      }
      this.nalaganjePoslovanje = false
    },
    ErrPreveriStatusEPoslovanja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    VklopimoEposlovanje () {
      let paramObvestilo = {}
      if (this.novEmailZaEposlovanje === undefined || this.novEmailZaEposlovanje === '') {
        paramObvestilo.message = 'Neuspešen vklop ePoslovanja. Prosimo, vpišite elektronski naslov.'
        this.ShowWarningMessage(paramObvestilo)
      } else if (!this.validacija.EmailValid(this.novEmailZaEposlovanje)) {
        paramObvestilo.message = 'Nepravilno vnešen elektronski naslov. Prosimo, poskusite ponovno.'
        this.ShowWarningMessage(paramObvestilo)
      } else if (this.izbranaStrankaSap !== '' && this.potrditevEposlovanje === false) {
        this.nalaganjePoslovanje = true
        let param = ['idStranka=' + this.izbranaStranka]
        param.push('email=' + this.novEmailZaEposlovanje)
        this.clientAgent.postWsRequest(
          this,
          'stranka/eposlovanje/vklopiEposlovanje',
          param,
          null,
          'SetVklopimoEposlovanje',
          'ErrVklopimoEposlovanje')
      }
    },
    async SetVklopimoEposlovanje () {
      await this.PreveriStatusEPoslovanja()
      let paramObvestilo = {}
      if (this.potrditevConfirmed !== undefined && this.potrditevConfirmed) {
        paramObvestilo.message = 'Hvala, da ste ponovno izbrali ePoslovanje. Prijetno uporabo želimo!'
      } else {
        paramObvestilo.message = 'Hvala, da ste izbrali ePoslovanje. Na vaš elektronski naslov smo poslali' +
            ' obvestilo. Prosimo, potrdite povezavo v sporočilu.'
      }
      this.ShowSuccessMessage(paramObvestilo)
      this.nalaganjePoslovanje = false
    },
    ErrVklopimoEposlovanje (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjePoslovanje = false
      this.soglasjeEmail = false
    },
    async IzklopimoEposlovanje () {
      if (this.izbranaStrankaSap !== '' && this.potrditevEposlovanje === true) {
        this.nalaganjePoslovanje = true
        MessageBox.confirm(
          'Ali ste prepričani, da želite Izključiti ePoslovanje?', {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          let param = ['idStranka=' + this.izbranaStranka]
          param.push('email=' + this.novEmailZaEposlovanje)
          this.clientAgent.postWsRequest(
            this,
            'stranka/eposlovanje/izklopiEposlovanje',
            param,
            null,
            'SetIzklopimoEposlovanje',
            'ErrIzklopimoEposlovanje')
        }).catch((err) => {
          err = null
          this.nalaganjePoslovanje = false
          this.PreveriStatusEPoslovanja()
        })
      }
    },
    async SetIzklopimoEposlovanje () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Žal nam je, da ste se odločili za ukinitev ePoslovanje. Brezplačno storitev' +
        ' ePoslovanje lahko kadarkoli ponovno aktivirate.'
      this.ShowSuccessMessage(paramObvestilo)
      await this.PreveriStatusEPoslovanja()
      this.nalaganjePoslovanje = false
    },
    ErrIzklopimoEposlovanje (podatki) {
      this.ShowSuccessMessage(podatki)
      this.nalaganjePoslovanje = false
    },
    PotrditevEmaila () {
      if (this.izbranaStrankaSap !== '') {
        let param = ['idStranka=' + this.izbranaStranka]
        this.clientAgent.postWsRequest(
          this,
          'stranka/eposlovanje/posljiPotrditveniEmail',
          param,
          null,
          'SetPotrditevEmaila',
          'ErrPotrditevEmaila')
      }
    },
    SetPotrditevEmaila () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Potrditveni email uspešno poslan.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrPotrditevEmaila (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/Eposlovanje/EposlovanjeComponent.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/EposlovanjeComponent.vue